@if (isLoading) {
  <div [ngClass]="[isOpened ? 'notification-container-show' : '', notificationClass]" class="loading-container">
    <div class="loading-text">
      <span class="loading-message">{{ message }}</span>
      <div class="loading-rotate right-container">
        <span class="icon icon-loading-circle"></span>
      </div>
    </div>
  </div>
}

@if (isNotification && !isLoading) {
  <div
    (click)="close()"
    [ngClass]="[isOpened ? 'notification-container-show' : '', isResolved ? 'notify-success' : '', notificationClass]"
    class="loading-container error-notification"
  >
    <div class="loading-text">
      <span class="loading-message">{{ message }}</span>
      @if (!isResolved) {
        <div class="loading-error right-container">
          <span class="icon icon-add"></span>
        </div>
      }
      @if (isResolved) {
        <div class="loading-success right-container">
          <span class="icon icon-double-checkmark"></span>
        </div>
      }
    </div>
  </div>
}

@if (!isNotification && !isLoading) {
  <div [ngClass]="[isOpened ? 'notification-container-show' : '', notificationClass]" class="loading-container">
    <div class="loading-text">
      <span class="loading-message">{{ message }}</span>
      <div class="buttons right-container">
        <div (click)="acceptPopup()" class="padding-popup">
          <!--        <span class="btn-small icon-double-checkmark"></span>-->
          <span class="icon icon-checkbox-round"></span>
        </div>
        <div (click)="rejectPopup()" class="loading-error">
          <!--        <span class="btn-small icon-add"></span>-->
          <span class="icon icon-remove-circle-filled-x"></span>
        </div>
      </div>
    </div>
  </div>
}
